import { useMutation } from '@tanstack/react-query';

import { postRemoveTaskLock, putAddTaskLock } from 'queries';
import { parseErrors, Toast } from 'helpers';
import { JsonDataItem } from 'types';

const useTaskLock = () => {
  const { mutate: addSoftlock } = useMutation(putAddTaskLock, {
    onError: (error: JsonDataItem) => {
      Toast.show({ description: parseErrors(error).join(', '), type: Toast.Type.Error });
    },
  });

  const { mutate: removeSoftlock } = useMutation(postRemoveTaskLock, {
    onError: (error: JsonDataItem) => {
      Toast.show({ description: parseErrors(error).join(', '), type: Toast.Type.Error });
    },
  });

  return { removeSoftlock, addSoftlock };
};

export { useTaskLock };
